(function () {
  'use strict';
  var root = document.querySelector('.tbvi[data-vi]');
  if (!root || root.dataset.viInitialized === 'true') return;
  root.dataset.viInitialized = 'true';

  // Alternate-template previews share /pages/program until the standalone Pages are created.
  var params = new URLSearchParams(window.location.search);
  var previewThemeId = params.get('preview_theme_id');
  var isAlternatePreview = window.location.pathname.replace(/\/$/, '') === '/pages/program' && /^program-vi-(blue|orange|purple)$/.test(params.get('view') || '');
  if (previewThemeId || isAlternatePreview) {
    root.querySelectorAll('[data-vi-self]').forEach(function (link) {
      link.setAttribute('href', window.location.pathname + window.location.search);
    });
    root.querySelectorAll('[data-vi-link]').forEach(function (link) {
      var variant = link.getAttribute('data-vi-link');
      var url = new URL('/pages/program', window.location.origin);
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      if (variant !== 'original') url.searchParams.set('view', 'program-vi-' + variant);
      link.setAttribute('href', url.pathname + url.search);
    });
  }

(function(){
  /* gallery carousel — fade slides, arrows, and clickable thumbnails */
  var main=root.querySelector('#pdpMain');
  if(!main)return;
  var slides=main.querySelectorAll('.pdp-slide');
  var n=slides.length; if(n<2)return;
  var thumbs=root.querySelectorAll('#pdpThumbs .pdp-thumb');
  var i=0;
  function go(idx){
    slides[i].classList.remove('is-active');slides[i].setAttribute('aria-hidden','true');
    if(thumbs[i]){thumbs[i].classList.remove('is-active');thumbs[i].setAttribute('aria-current','false');}
    i=(idx+n)%n;
    slides[i].classList.add('is-active');slides[i].setAttribute('aria-hidden','false');
    if(thumbs[i]){thumbs[i].classList.add('is-active');thumbs[i].setAttribute('aria-current','true');}
  }
  for(var t=0;t<thumbs.length;t++){
    (function(thumb){thumb.addEventListener('click',function(){go(parseInt(thumb.getAttribute('data-pdp-index'),10)||0);});})(thumbs[t]);
  }
})();


(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items=[];
  [].forEach.call(root.querySelectorAll('.ugcfold .ugc-card'),function(card){
    var v=card.querySelector('.ugc-vid'); if(!v)return;
    items.push({v:v,show:function(){card.classList.add('is-loading');},hide:function(){card.classList.remove('is-loading');}});
  });
  [].forEach.call(root.querySelectorAll('.fixfold .ff-video'),function(v){
    var l=root.querySelector('#ffLoading');
    items.push({v:v,show:function(){if(l)l.classList.remove('is-hidden');},hide:function(){if(l)l.classList.add('is-hidden');}});
  });
  if(!items.length)return;
  items.forEach(function(it){
    var v=it.v; it.hide();
    ['playing','canplay','loadeddata'].forEach(function(ev){v.addEventListener(ev,it.hide);});
    it.start=function(){
      if(reduce)return;
      if(v.readyState<3){it.show();}
      if(v.preload!=='auto'){v.preload='auto';}
      var p=v.play(); if(p&&p.catch){p.catch(function(){it.hide();});}
      setTimeout(it.hide,10000);
    };
  });
  function find(t){for(var i=0;i<items.length;i++){if(items[i].v===t)return items[i];}return null;}
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){var it=find(e.target);if(!it)return;
        if(e.isIntersecting){it.start();}
        else{if(!e.target.paused){try{e.target.pause();}catch(_){}}it.hide();}
      });
    },{threshold:0.35});
    items.forEach(function(it){io.observe(it.v);});
  } else { items.forEach(function(it){it.start();}); }
  function resume(){
    var vh=window.innerHeight||document.documentElement.clientHeight;
    items.forEach(function(it){var r=it.v.getBoundingClientRect();if(r.top<vh&&r.bottom>0){it.start();}});
  }
  document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible'){resume();}});
  window.addEventListener('pageshow',resume);
  window.addEventListener('focus',resume);
})();


(function(){
  var grid=root.querySelector('#revwallGrid');
  if(!grid)return;
  var moreBtn=root.querySelector('#revwallMore');
  var sortSel=root.querySelector('#revwallSort');
  var PAGE=6, expanded=false;
  function cards(){return Array.prototype.slice.call(grid.querySelectorAll('.rev-card'));}
  function num(c,a){return parseInt(c.getAttribute(a),10)||0;}
  function applyVis(){
    cards().forEach(function(c,i){
      if(expanded||i<PAGE){c.classList.remove('rev-hidden');}else{c.classList.add('rev-hidden');}
    });
    if(moreBtn){moreBtn.style.display=(expanded||cards().length<=PAGE)?'none':'block';}
  }
  function sortBy(k){
    cards().sort(function(a,b){
      if(k==='oldest')return num(a,'data-ts')-num(b,'data-ts');
      if(k==='helpful')return num(b,'data-helpful')-num(a,'data-helpful');
      if(k==='highest')return num(b,'data-rating')-num(a,'data-rating')||num(b,'data-ts')-num(a,'data-ts');
      if(k==='lowest')return num(a,'data-rating')-num(b,'data-rating')||num(b,'data-ts')-num(a,'data-ts');
      return num(b,'data-ts')-num(a,'data-ts');
    }).forEach(function(c){grid.appendChild(c);});
    applyVis();
  }
  if(moreBtn){moreBtn.addEventListener('click',function(){expanded=true;applyVis();});}
  if(sortSel){sortSel.addEventListener('change',function(){sortBy(sortSel.value);});}
  function jumpRev(t){
    if(!t)return;
    var from=window.pageYOffset;
    t.scrollIntoView({behavior:'smooth',block:'start'});
    setTimeout(function(){
      if(Math.abs(window.pageYOffset-from)<60){t.scrollIntoView({block:'start'});}
    },500);
  }
  function jumpable(el,target){
    if(!el||!target)return;
    el.addEventListener('click',function(){jumpRev(target);});
    el.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();jumpRev(target);}});
  }
  jumpable(root.querySelector('.pdp-rating'),root.querySelector('#reviews-all'));
  jumpable(root.querySelector('.revwall-summary'),grid);
  root.querySelectorAll('.rev-vote').forEach(function(v){
    v.addEventListener('click',function(){
      if(v.classList.contains('voted'))return;
      var c=v.querySelector('.rev-votecount');
      if(c){c.textContent=(parseInt(c.textContent,10)||0)+1;}
      v.classList.add('voted');
    });
  });
  sortBy('recent');
})();


(function () {
  var lb = root.querySelector('#imgLightbox');
  if (!lb) return;
  var lbImg = lb.querySelector('.imglb-img');
  var closeButton = lb.querySelector('.imglb-close');
  var previousFocus = null;
  function openLb(img) {
    if (!img || !(img.currentSrc || img.src)) return;
    previousFocus = document.activeElement;
    lbImg.width = img.naturalWidth || 1254;
    lbImg.height = img.naturalHeight || 1254;
    lbImg.src = img.currentSrc || img.src;
    lbImg.alt = img.alt || '';
    lb.hidden = false;
    document.documentElement.classList.add('imglb-open');
    closeButton.focus();
  }
  function closeLb() {
    if (lb.hidden) return;
    lb.hidden = true;
    lbImg.removeAttribute('src');
    document.documentElement.classList.remove('imglb-open');
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll: true});
  }
  lb.addEventListener('click', closeLb);
  document.addEventListener('keydown', function (event) {
    if (lb.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeLb(); }
    else if (event.key === 'Tab') { event.preventDefault(); closeButton.focus(); }
  });
  function activate(el, image) {
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-haspopup', 'dialog');
    if (el.tagName === 'IMG') el.setAttribute('aria-label', 'Enlarge image: ' + (el.alt || 'project photo'));
    el.addEventListener('click', function () { openLb(image()); });
    el.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openLb(image()); }
    });
  }
  root.querySelectorAll('.wk-tile img, .mediaslot img, .rev-photo, .program-hiw__image img').forEach(function (img) {
    activate(img, function () { return img; });
  });
  var main = root.querySelector('#pdpMain');
  if (main) activate(main, function () { return main.querySelector('.pdp-slide.is-active'); });
})();


(function(){
  /* Lazy images on this page sometimes never fire their load — the gallery slides
     sit at opacity 0 and the offer thumbs are far down the DOM, and both have shown
     up blank / broken for real visitors. Once the page has loaded (so LCP is already
     measured against the eager hero image) promote every remaining lazy image to
     eager so nothing is still downloading when the visitor scrolls or swipes to it. */
  function warmLazyImages(){
    var imgs = root.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].loading = 'eager'; }
  }
  if (document.readyState === 'complete') { warmLazyImages(); }
  else { window.addEventListener('load', warmLazyImages); }

  /* mobile hamburger menu */
  var mb = root.querySelector('#tekneMenuBtn'), mm = root.querySelector('#tekneMobileMenu');
  if (mb && mm) {
    mb.addEventListener('click', function(){
      var open = mm.classList.toggle('open');
      mb.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mm.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ mm.classList.remove('open'); mb.setAttribute('aria-expanded','false'); });
    });
  }
  /* sticky mobile bar — appears once the hero CTA has scrolled past the viewport midpoint */
  var bar = root.querySelector('#tekneStickybar'), heroCta = root.querySelector('#pdpCta'), shown = false;
  function onScroll(){
    var show;
    if (heroCta) {
      show = heroCta.getBoundingClientRect().bottom < window.innerHeight * 0.5;
    } else {
      show = (window.scrollY || document.documentElement.scrollTop) > 700;
    }
    if (show !== shown) { shown = show; bar && bar.classList.toggle('on', show); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();

})();
